/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApplicationFormDto } from './ApplicationFormDto';
import {
    ApplicationFormDtoFromJSON,
    ApplicationFormDtoFromJSONTyped,
    ApplicationFormDtoToJSON,
    ApplicationFormDtoToJSONTyped,
} from './ApplicationFormDto';

/**
 * 
 * @export
 * @interface PagedApplicationFormDto
 */
export interface PagedApplicationFormDto {
    /**
     * 
     * @type {Array<ApplicationFormDto>}
     * @memberof PagedApplicationFormDto
     */
    content: Array<ApplicationFormDto>;
    /**
     * 
     * @type {number}
     * @memberof PagedApplicationFormDto
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof PagedApplicationFormDto
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof PagedApplicationFormDto
     */
    numberOfElements: number;
    /**
     * 
     * @type {boolean}
     * @memberof PagedApplicationFormDto
     */
    last: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedApplicationFormDto
     */
    totalPages: number;
    /**
     * 
     * @type {boolean}
     * @memberof PagedApplicationFormDto
     */
    first: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedApplicationFormDto
     */
    totalElements: number;
    /**
     * 
     * @type {boolean}
     * @memberof PagedApplicationFormDto
     */
    empty: boolean;
}

/**
 * Check if a given object implements the PagedApplicationFormDto interface.
 */
export function instanceOfPagedApplicationFormDto(value: object): value is PagedApplicationFormDto {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('numberOfElements' in value) || value['numberOfElements'] === undefined) return false;
    if (!('last' in value) || value['last'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    if (!('first' in value) || value['first'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    if (!('empty' in value) || value['empty'] === undefined) return false;
    return true;
}

export function PagedApplicationFormDtoFromJSON(json: any): PagedApplicationFormDto {
    return PagedApplicationFormDtoFromJSONTyped(json, false);
}

export function PagedApplicationFormDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedApplicationFormDto {
    if (json == null) {
        return json;
    }
    return {
        
        'content': ((json['content'] as Array<any>).map(ApplicationFormDtoFromJSON)),
        'number': json['number'],
        'size': json['size'],
        'numberOfElements': json['numberOfElements'],
        'last': json['last'],
        'totalPages': json['totalPages'],
        'first': json['first'],
        'totalElements': json['totalElements'],
        'empty': json['empty'],
    };
}

export function PagedApplicationFormDtoToJSON(json: any): PagedApplicationFormDto {
    return PagedApplicationFormDtoToJSONTyped(json, false);
}

export function PagedApplicationFormDtoToJSONTyped(value?: PagedApplicationFormDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': ((value['content'] as Array<any>).map(ApplicationFormDtoToJSON)),
        'number': value['number'],
        'size': value['size'],
        'numberOfElements': value['numberOfElements'],
        'last': value['last'],
        'totalPages': value['totalPages'],
        'first': value['first'],
        'totalElements': value['totalElements'],
        'empty': value['empty'],
    };
}

